import { ContextMenuActionKey, ContextMenuItem } from '@Types/v1';
import { extractEmail } from '@Utils/common';
import customConfig from 'src/config';

export const handleBlockSenderCtxMenu = (sender: string) => {
  if (!customConfig.ui.contextMenuEnabled) {
    return;
  }
  try {
    if (!window.xdrContextMenu) {
      console.error('xdrContextMenu cannot be found');
      return;
    }

    const mailbox = extractEmail(sender);

    const res: ContextMenuItem[] = window.xdrContextMenu.query(
      'EmailAccount',
      [
        { key: 'source_name', value: 'cas' },
        { key: 'source_id', value: '' },
        { key: 'target_type', value: 'EmailAccount' },
        { key: 'mailbox', value: mailbox },
        { key: 'product_code', value: 'sca' },
      ],
      true,
      false
    );

    const blockSenderRes = res.find(
      (v) => v.action_key === ContextMenuActionKey.BlockSender
    );

    if (!blockSenderRes) {
      throw new Error(
        'xdrContextMenu query blockSender not get the expected data'
      );
    }

    window.xdrContextMenu.takeAction({
      action_type: blockSenderRes.action_type,
      action_url: blockSenderRes.action_url,
      action_key: blockSenderRes.action_key,
      target_type: blockSenderRes.target_type,
      action_data: {
        mailbox,
      },
    });
  } catch (e) {
    console.error(e);
  }
};
